"use client";

import type { Icon } from "@layer/icons";
import { ToggleGroup, ToggleGroupItem } from "@layer/ui/components";
import { cn } from "@layer/utils/cn";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

type ThemeToggleProps = {
	orientation?: "horizontal" | "vertical";
	themes: { value: string; icon: Icon }[];
};

const ThemeToggle = ({
	orientation = "horizontal",
	themes,
}: ThemeToggleProps) => {
	const [mounted, setMounted] = useState(false);
	const { setTheme, theme } = useTheme();
	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) {
		return null;
	}

	return (
		<ToggleGroup
			type="single"
			isSettings
			className={cn(
				orientation === "horizontal" ? "flex-row" : "flex-col",
			)}
			value={theme}
			onValueChange={(value) => {
				if (!value) return;
				setTheme(value);
			}}
		>
			{themes.map((t) => {
				const { value, icon: Icon } = t;
				return (
					<ToggleGroupItem
						isSettings
						key={value}
						value={value}
						aria-label="Toggle light theme"
					>
						<Icon
							variant={theme === value ? "filled" : "duotone"}
							className="h-3 w-3"
						/>
					</ToggleGroupItem>
				);
			})}
		</ToggleGroup>
	);
};

export { ThemeToggle };
